import React from 'react';

// Required "I agree" checkbox used by driver applications and team invitations.
export const TermsConsentCheckbox = ({ checked, onChange, testid = 'terms-consent-checkbox', compact = false }) => (
  <label className={`flex items-start gap-3 text-sm text-slate-800 cursor-pointer ${compact ? 'mt-3' : 'p-4 border border-slate-200 rounded-md bg-slate-50'}`}
    style={{ fontFamily: 'IBM Plex Sans, sans-serif' }} data-testid={`${testid}-label`}>
    <input type="checkbox" required checked={checked} onChange={(e) => onChange(e.target.checked)} className="mt-0.5 h-4 w-4 accent-[#002FA7]" data-testid={testid} />
    <span>
      I have read and agree to the CivilX TMS{' '}
      <a href="/terms" target="_blank" rel="noreferrer" className="text-[#002FA7] font-semibold hover:underline" data-testid={`${testid}-terms-link`}>Terms of Service</a>
      {' '}and{' '}
      <a href="/privacy-policy" target="_blank" rel="noreferrer" className="text-[#002FA7] font-semibold hover:underline" data-testid={`${testid}-privacy-link`}>Privacy Policy</a>.
      Your acceptance is recorded with the document version.
    </span>
  </label>
);

export default TermsConsentCheckbox;
